<template>
  <v-data-table
    v-bind="$attrs"
    :headers="headers"
    :items="items"
    :options.sync="options"
    hide-default-footer
    v-on="$listeners"
    :class="tableClass"
  >
    <!-- pass through normal slots -->
    <template v-for="(_, name) in $slots" #[name]>
      <slot :name="name" />
    </template>

    <!-- pass through scoped slots -->
    <template v-for="(_, scopedName) in $scopedSlots" #[scopedName]="slotData">
      <slot :name="scopedName" v-bind="slotData" />
    </template>

    <template #footer>
      <v-pagination
        v-if="pageCount > 1"
        v-model="options.page"
        :length="pageCount"
        :total-visible="totalVisible"
      ></v-pagination>
    </template>
  </v-data-table>
</template>

<script>
export default {
  name: "Table",
  components: {},
  mixins: [],
  props: {
    headers: {
      type: Array,
      required: true,
    },
    items: { type: Array, required: false, default: () => [] },
    itemsPerPage: {
      type: Number,
      required: false,
      default: 10,
    },
    totalVisible: { type: Number, required: false, default: 7 },
    sortBy: { type: Array, required: false, default: () => [] },
    rowPointer: { type: Boolean, required: false, default: false },
  },
  data() {
    return {
      options: {
        page: 1,
        itemsPerPage: this.itemsPerPage,
        sortBy: this.sortBy,
        sortDesc: [],
        groupBy: [],
        groupDesc: [],
        multiSort: false,
        mustSort: false,
      },
    };
  },
  computed: {
    pageCount() {
      return Math.ceil(this.items.length / this.itemsPerPage);
    },
    tableClass() {
      const classes = [];
      if (this.rowPointer) {
        classes.push("row-pointer");
      }
      return classes;
    },
  },
};
</script>

<style>
th {
  vertical-align: top;
}
.row-pointer > .v-data-table__wrapper > table > tbody > tr :hover {
  cursor: pointer;
}
</style>
